import notifyUser from "@/helpers/notifyUser.js";

export default async function (file) {
    if (file.type === 'application/pdf') {
        let reader = new FileReader();
        reader.readAsArrayBuffer(file);
        return await new Promise((res) => {
            reader.onload = (e) => res(new Uint8Array(e.target.result));
        });
    } else {
        try {
            let formData = new FormData();
            formData.append("file", file);

            const result = await axios.post(route('convert.docx'), formData, {responseType: 'arraybuffer'});
            return new Uint8Array(result.data);
        } catch (e) {
            if (e?.response?.status === 429) {
                notifyUser('Слишком много конвертаций, пожалуйста, подождите или загрузите PDF');
            } else if (e?.response?.status === 422) {
                const responseJson = JSON.parse(new TextDecoder().decode(e.response.data));
                notifyUser(responseJson.message);
            } else {
                notifyUser('Произошла ошибка при конвертации файла');
                throw e;
            }
        }

        return null
    }
}
